import { ISetChatTypeAction } from "../interfaces/utils.interface";
export function setCustomerSupportChat(customerSupportChat: string): ISetChatTypeAction {
  return {
    type: "CHAT_TYPE",
    data: customerSupportChat,
  };
}
